import React from 'react';

// import components
import Calendar from "components/partials/calendar";

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";

const CalendarBuilder: React.FC<{ calendarData?: Queries.CalendarGraphicBlockFragment }> = ({ calendarData }) => {

    if (!calendarData) return null;

    let image = isGatsbyImageData(calendarData.image?.gatsbyImageData) ? calendarData.image?.gatsbyImageData : undefined;

    return (
        <Calendar
            image={image}
            imageAlt={calendarData.image?.alt ?? ''}
            htmlContent={calendarData.textContent?.content ?? ''}
        />
    );
};

export default CalendarBuilder;